import { useMemo } from "react";
import { useSelector } from "react-redux";
import { dualStreamEnabled } from "../shared/utility";
import { isEmpty } from "lodash";
import { GLOBAL_MEETING_DATA } from "../constants/PublicVariables";
import useCheckCallConnected from "./useCheckCallConnected";
import uploadFilesService from "../services/uploadFilesService";

const useShowGalleryViewTooltip = () => {
    const { expandView } = useSelector((state) => state.commonReducer);
    const { screenSharingUsers, videoStreamingUsers } = useSelector((state) => state.twilioEvents);
    const isCallNotConnected = useCheckCallConnected(); // call connect but video/screenshare not strat

    const showTooltip = useMemo(() => {
        return (
            GLOBAL_MEETING_DATA.isAgent &&
            dualStreamEnabled() &&
            !expandView &&
            isCallNotConnected &&
            !uploadFilesService.isUploadFilesView() &&
            (!isEmpty(videoStreamingUsers) || !isEmpty(screenSharingUsers))
        );
    }, [expandView, screenSharingUsers, videoStreamingUsers, isCallNotConnected]);

    return showTooltip;
};

export default useShowGalleryViewTooltip;
